import { render, staticRenderFns } from "./EmergencyIncidentDialog.vue?vue&type=template&id=53b084ee"
import script from "./EmergencyIncidentDialog.vue?vue&type=script&lang=js"
export * from "./EmergencyIncidentDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports